// If you are using CommonJS modules:
const { Dropzone } = require("dropzone");

var text_RemoveFileConfirmation = "Sind Sie sicher?",
    text_FileTooBig = "Datei ist zu gross ({{filesize}}MB). Maximal {{maxFilesize}}MB relaubt.",
    text_InvalidFileType = "Ungültiger Dateityp",
    text_CancelUpload = "Abbrechen",
    text_RemoveFile = "Entfernen",
    text_MaxFilesExceeded = "Maximal 1 erlaubt",
    text_DefaultMessage = "PDF oder JPG wählen",
    url_pfad = "/de/uploads/fileupload/",
    url_del_pfad = "/de/uploads/filedelete/";

var options_single_pdf = {
    url: url_pfad,
    method: "POST",
    paramName: "file",
    autoProcessQueue : true,
    acceptedFiles: "application/pdf,image/jpeg",
    maxFiles: 15,
    maxFilesize: 5, // MB
    uploadMultiple: false,
    createImageThumbnails: false,
    addRemoveLinks: false,
    timeout: 180000,
    dictRemoveFileConfirmation: text_RemoveFileConfirmation, // ask before removing file
    // Language Strings
    dictFileTooBig: text_FileTooBig,
    dictInvalidFileType: text_InvalidFileType,
    dictCancelUpload: text_CancelUpload,
    dictRemoveFile: text_RemoveFile,
    dictMaxFilesExceeded: text_MaxFilesExceeded,
    dictDefaultMessage: text_DefaultMessage
};

// all dropzone elements
const drop_elements = document.querySelectorAll('.dropzone');
const httpRequest = new XMLHttpRequest();
// save file to db
const einsatztag = document.querySelector("[name='einsatztag_id']");
const einsatz_tl = document.querySelector("[name='einsatz_tl_id']");
const save_form_url = "/de/requests/modal/";
/*
const dropzones = [];
const drop_route_pdf = new Dropzone("#dropzone_tl_route_pdf", options_single_pdf);
dropzones.push(drop_route_pdf);
const drop_tl_document1 = new Dropzone("#dropzone_tl_document1", options_single_pdf);
dropzones.push(drop_tl_document1);
const drop_tl_document2 = new Dropzone("#dropzone_tl_document2", options_single_pdf);
dropzones.push(drop_tl_document2); 
const drop_document = new Dropzone("#dropzone_dokument", options_single_pdf);
dropzones.push(drop_document);
*/

function deleteFile(pv_element, msg_element, current_file, input_el, del_button, show_button) {
    var response_out, filename, input_element, confirmed;
    var del_db_result = false;

    // delete event
    if (del_button) {
        del_button.addEventListener('click', function( event ) {
            // get saved filename
            filename = input_el.getAttribute('value');
            input_element = input_el.getAttribute('id');

            confirmed = confirm("Eintrag wirklich löschen?");
            if (confirmed) {
                // response
                httpRequest.onreadystatechange = function () {
                    if (httpRequest.readyState === 4 && httpRequest.status === 200) {
                    // add new html
                    response_out = httpRequest.response;
                        // update offset if more videos
                        if (response_out === 'ok') {
                            // delete from table - empty file
                            if (input_element) {
                                // wenn nicht spesen-quittung!
                                if (input_element !== 'zusatzaufwaende_receipt') {
                                    // aus db löschen
                                    del_db_result = saveFileDB(input_element, '');
                                }
                            }
                            // empty value
                            input_el.setAttribute('value', '');
                            // hide/show elements
                            del_button.style.display = 'none';
                            // remove href and hide
                            show_button.href = '';
                            show_button.style.display = 'none';

                            // remove dropzone preview
                            if (pv_element) {
                                pv_element.remove();
                            }
                            if (current_file) {
                                current_file.remove();
                            }
                            msg_element.style.display = 'block';

                            // reset input??
                        }
                    }
                };

                // request
                httpRequest.open('POST', url_del_pfad, true);
                httpRequest.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
                httpRequest.send('action=delete&upload_path=botschafter_media&filename=' + encodeURIComponent(filename));
            }
    
        });
    }
}

function saveFileDB(input_name, file) {
    var type, input_id_name, data, id=0;

    if (input_name) {
        // get id val and inputname
        if (einsatztag) {
            id = einsatztag.value; // const
            type = 'einsatztag_details';
            input_id_name = 'einsatztag';
        }
        if (einsatz_tl) {
            id = einsatz_tl.value; // const
            type = 'tl_info';
            input_id_name = 'einsatz_tl';
        }

        // response
        httpRequest.onreadystatechange = function () {
          if (httpRequest.readyState === 4 && httpRequest.status === 200) {
            // add new html
            data = JSON.parse(httpRequest.response);
            if (data.message !== true) {
                alert('Änderung konnte nicht in der Datenbank gespeichert werden.')
            }
          }
        };

        // request
        httpRequest.open('POST', save_form_url, true);
        httpRequest.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        httpRequest.send('form_name='+type+'&' + input_id_name + '_id='+id+'&'+input_name+'=' + encodeURIComponent(file));
    }
}

if (drop_elements) {

    var dzone,
        current_file, 
        input_el, 
        d_element,
        del_button,
        show_button,
        el_id,
        str;

    drop_elements.forEach(function (drop_element) {
        // new dropzone
        dzone = new Dropzone(drop_element, options_single_pdf);
        // get input element
        d_element = document.getElementById(dzone.element.id);

        if (d_element) {
            el_id = d_element.dataset.id;
            
            input_el = document.getElementById(el_id);
            del_button = document.getElementById('del-'+el_id);
            show_button = document.getElementById('show-'+el_id);
            current_file = document.getElementById('pv-'+el_id);

            str = input_el.getAttribute('value');
            if (typeof str === 'string' && str.trim().length === 0) {
                del_button.style.display = 'none';
            } else {
                var pv_element;
                var msg_element = dzone.element.querySelector('.dz-message')
                msg_element.style.display = 'none';
                // delete file
                deleteFile(pv_element, msg_element, current_file, input_el, del_button, show_button);
            }
        }

        // on success, add to input to save
        dzone.on("successmultiple", function(file, response) {
            //input_el.setAttribute('value',response.files);
            //del_button.style.display = 'block';
        });
        dzone.on("success", function(file, response) {

            var pv_element = file.previewElement;
            var preview_name = pv_element.querySelector('.dz-filename');

            var el_parent = file.previewElement.parentElement;
            var msg_element = el_parent.querySelector('.dz-message');

            if (preview_name) {
                preview_name.innerHTML = response.files;
            }
            var el_id = el_parent.dataset.id;
            if (el_id) {
                input_el = document.getElementById(el_id);
                del_button = document.getElementById('del-'+el_id);
                show_button = document.getElementById('show-'+el_id);
                input_el.setAttribute('value',response.files);
                del_button.style.display = 'inline-block';
                // add href link and show
                if (preview_name.innerText !== '') {
                    show_button.href = '/botschafter_media/'+preview_name.innerText;
                    show_button.style.display = 'inline-block'; 
                }
                
                // emtpy var
                current_file;

                // wenn nicht spesen-quittung!
                if (el_id !== 'zusatzaufwaende_receipt') {
                    // direkt in db speichern
                    saveFileDB(el_id, response.files);
                }

                // delete file button
                deleteFile(pv_element, msg_element, current_file, input_el, del_button, show_button);
            }
        });
        
        dzone.on("error", function(file, response) {
            //console.log(response);
        });
    });
};

export {deleteFile};